/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.entity', [])
    .factory('entityService', EntityService)
    .name;

/*@ngInject*/
function EntityService($q, types, providerService, providerSubscriptionService,
                       customerSubscriptionService, userService, customerService,
                       gatewayModelService, gatewayGroupService) {

    var service = {
        getEntities: getEntities,
        getEntity: getEntity
    }

    return service;

    function getEntities(entityType) {
        var deferred = $q.defer();
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;

        var getEntitiesPromise;
        switch (entityType) {
            case types.entityType.provider:
                getEntitiesPromise = providerService.getProviders();
                break;
            case types.entityType.customer:
                getEntitiesPromise = customerService.getCustomers();
                break;
            case types.entityType.provider_subscription:
                getEntitiesPromise = providerSubscriptionService.getProviderSubscriptions();
                break;
            case types.entityType.customer_subscription:
                getEntitiesPromise = customerSubscriptionService.getCustomerSubscriptions();
                break;
            case types.entityType.gateway_model:
                getEntitiesPromise = gatewayModelService.getProviderGatewayModels();
                break;
            case types.entityType.gateway_group:
                if (scope == types.scope.provider) {
                    getEntitiesPromise = gatewayGroupService.getProviderGatewayGroups();
                } else if (scope == types.scope.customer) {
                    getEntitiesPromise = gatewayGroupService.getCustomerGatewayGroups(currentUser.customerId);
                }
                break;
        }
        if (getEntitiesPromise) {
            getEntitiesPromise.then((entities) => {
                deferred.resolve(entities);
            },
            () => {
                deferred.reject();
            });
        } else {
            deferred.reject();
        }

        return deferred.promise;
    }

    function getEntity(entityId) {
        var deferred = $q.defer();
        var getEntityPromise;
        switch (entityId.entityType) {
            case types.entityType.provider:
                getEntityPromise = providerService.getProvider(entityId.id);
                break;
            case types.entityType.customer:
                getEntityPromise = customerService.getCustomer(entityId.id);
                break;
            case types.entityType.provider_subscription:
                getEntityPromise = providerSubscriptionService.getProviderSubscription(entityId.id);
                break;
            case types.entityType.customer_subscription:
                getEntityPromise = customerSubscriptionService.getCustomerSubscription(entityId.id);
                break;
            case types.entityType.gateway_model:
                getEntityPromise = gatewayModelService.getGatewayModel(entityId.id);
                break;
            case types.entityType.gateway_group:
                getEntityPromise = gatewayGroupService.getGatewayGroup(entityId.id);
                break;
        }
        if (getEntityPromise) {
            getEntityPromise.then((entity) => {
                    deferred.resolve(entity);
                },
                () => {
                    deferred.reject();
                });
        } else {
            deferred.reject();
        }
        return deferred.promise;
    }

}


// WEBPACK FOOTER //
// ./src/app/api/entity.service.js